<template>
    <div id="systemmodule">
        <HrrBreadcrumb PMname="信息管理" CMname="站点信息管理" />
        <HrrDetailLayout>
            <template slot="head">
                {{title}}
            </template>
            <template slot="Form">
                <el-form status-icon :model="form" ref="form" :rules="rules" label-width="110px" class="el-form-module" :hide-required-asterisk="isView">
                    <el-form-item label="站点名称：" prop="siteName">
                        <el-input v-model="form.siteName" v-if="isAdd||isEdit" ></el-input>
                        <span v-if="isView">
                            {{form.siteName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="站点描述：" prop="siteDesc">
                        <el-input v-model="form.siteDesc" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.siteDesc}}
                        </span>
                    </el-form-item>
                    <el-form-item label="站点类型：" prop="siteType">
                        <el-select v-model="form.siteType"  placeholder="请选择站点类型" v-if="isAdd||isEdit"  filterable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                            </el-select>
                        <span v-if="isView">
                            {{form.siteType}}
                        </span>
                    </el-form-item>
                    <el-form-item label="楼层数：" prop="floor">
                        <el-input v-model="form.floor" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.floor}}
                        </span>
                    </el-form-item>
                    <el-form-item label="经度：" prop="lon">
                        <el-input v-model="form.lon" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.lon}}
                        </span>
                    </el-form-item>
                    <el-form-item label="纬度：" prop="lat">
                        <el-input v-model="form.lat" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.lat}}
                        </span>
                    </el-form-item>
                    <el-form-item label="省：" prop="provinceId">
                            <el-select v-model="form.provinceId"  @change="changeProvinceId" placeholder="请选择省" v-if="isAdd||isEdit"  filterable>
							<el-option v-for="item in siteidData" 
							:key="item.name"
							:label="item.name" 
							:value="item.name">
							</el-option>
						</el-select>
                        <span v-if="isView">
                            {{form.provinceId}}
                        </span>
                    </el-form-item>
                    <el-form-item label="市：" prop="cityId">
                            <el-select v-model="form.cityId" @change="changeCity" placeholder="请选择市" v-if="isAdd||isEdit"  filterable>
							<el-option v-for="item in siteidCityData" 
							:key="item.name"
							:label="item.name" 
							:value="item.name">
							</el-option>
						</el-select>
                        <span v-if="isView">
                            {{form.cityId}}
                        </span>
                    </el-form-item>
                    <el-form-item label="区：" prop="countyId">
                            <el-select v-model="form.countyId" @change="changeCounty" placeholder="请选择区" v-if="isAdd||isEdit"  filterable>
							<el-option v-for="item in siteidCountyData" 
							:key="item.name"
							:label="item.name" 
							:value="item.name">
							</el-option>
						</el-select>
                        <span v-if="isView">
                            {{form.countyId}}
                        </span>
                    </el-form-item>
                    <el-form-item label="站点地址：" prop="siteAddress">
                        <el-input v-model="form.siteAddress" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.siteAddress}}
                        </span>
                    </el-form-item>
                    <el-form-item label="状态：" prop="status">
                        <el-radio-group v-model="form.status">
                            <el-radio :label="1" :disabled="isView">启用</el-radio>
                            <el-radio :label="0" :disabled="isView">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button type="primary" @click="submitMForm('form')" v-if="isAdd||isEdit">提 交</el-button>
                <el-button @click="resetMForm('form')" v-if="isAdd||isEdit">重 置</el-button>
                <el-button type="info" @click="returnMForm()">返 回</el-button>
            </template>
        </HrrDetailLayout>
    </div>
</template>
<script>
export default {
    name: 'siteDetail',
    data() {
        return {
            form: {
                siteId: 0,
                siteName:"",
                siteDesc:"",
                siteType:"",
                floor:"",
				lon:"",
                lat:"",
                siteAddress:"",
                provinceId:"",
				cityId:"",
				countyId:"",
                status: 1,
            },
            options: [{
            value: '地铁站',
            label: '地铁站'
            }, {
            value: '公交站',
            label: '公交站'
            }, {
            value: '机场',
            label: '机场'
            }, {
            value: '其他',
            label: '其他'
            }],
            rules: {
                siteName: [{ required: true, message: '请输入站点名称', trigger: 'blur' }],
                siteDesc: [{ required: true, message: '请输入站点描述', trigger: 'blur' }],
                siteType: [{ required: true, message: '请输入站点类型', trigger: 'blur' }],
                floor: [{ required: true, message: '请输入楼层数', trigger: 'blur' }],
                lon: [{ required: true, message: '请输入经度', trigger: 'blur' }],
                lat: [{ required: true, message: '请输入纬度', trigger: 'blur' }],
                siteAddress: [{ required: true, message: '请输入站点地址', trigger: 'blur' }],
                provinceId: [{ required: true, message: '请输入省', trigger: 'change' }],
                cityId: [{ required: true, message: '请输入市', trigger: 'change' }],
                countyId: [{ required: true, message: '请输入区', trigger: 'change' }],
            },
            title: "",
            isEdit: true,
            isAdd: false,
            isView: false,
            siteidData:[],
            siteidCity:null,
            siteidCityData:[],
            siteidCounty:null,
            siteidCountyData:[],
            returnPath:""
            //AllOrgListData:[]
        }
    },
    methods: {
         changeProvinceId(val) {
              this.siteidCity=val;
              this.form.cityId=""
              this.initData();
        },
        changeCity(val){
            this.siteidCounty=val;
            this.form.countyId=""
            this.initData();
        },
        changeCounty(val){
            var info="";
            if(this.form.provinceId.indexOf("市")>0){
                info=this.form.provinceId+val;
            }else{
                info=this.form.provinceId+this.form.cityId+val;
            }
            this.form.siteAddress=info;
        },
        submitMForm: function(formName) {
            //console.log(this.returnPath);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var apiUrl = this.isAdd ? this.$api.site.AddSite : this.$api.site.AddSite + "/" + this.form.siteId;
                    var m = this.isAdd ? "POST" : "PUT";
                    this.$hrraxios({
                            method: m,
                            url: apiUrl,
                            data: this.form
                        })
                        .then(function(response) {
                            loading.close();
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$alert("提交成功！", {
                                    callback: action => {
                                        Vuethis.$router.push({ path: Vuethis.returnPath });
                                    }
                                });
                            } else {
                                Vuethis.$message({ message: data.Prompt, type: "error" });
                            }
                        }).catch(function(error) {
                            loading.close();
                            console.log(error);
                        })
                } else {
                    return false;
                }
            });
        },
        resetMForm: function(formName) {
            this.$refs[formName].resetFields();
        },
        returnMForm: function() {
            this.$router.go(-1);
        },
        initData: function() {
            this.isView = false;
            this.isEdit = false;
            this.isAdd = false;
            var Hrrtype = this.$route.params.type; //类型
            var row = this.$route.meta.row;
            var info = "站点信息";
            if (Hrrtype != "add") {
                this.form = row;
                this.$route.meta.row = null;
            }
            if (Hrrtype == "view") {
                this.title = "查看" + info;
                this.isView = true;
            }
            if (Hrrtype == "edit") {
                this.title = "编辑" + info;
                this.isEdit = true;

            }
            if (Hrrtype == "add") {
                this.title = "新增" + info;
                this.isAdd = true;
            }
            var myVuethis = this;
            //所属地铁站 $hrraxios
            this.axios.get('/js/city.js')
                .then((response) => {
                    //console.log(response.data);
                    var cityData=response.data;
                    if(this.siteidCity==null){
                        for(var i=0; i<cityData.length;i++){
                                let obj = {
                                name:cityData[i].name
                                }
                               myVuethis.siteidData.push(obj);
                        };
                    }
                    if(this.siteidCity!=null){
                        this.siteidCityData=[];
                        for(var i=0; i<cityData.length;i++){
                            if(cityData[i].name==myVuethis.siteidCity){
                                for(var n=0; n<cityData[i].city.length;n++){
                                    let obj = {
                                    name:cityData[i].city[n].name,
                                    area:cityData[i].city[n].area
                                    }
                                    myVuethis.siteidCityData.push(obj);
                                }
                            }
                        };
                    }
                    if(this.siteidCounty!=null){
                          this.siteidCountyData=[];
                        for(var i=0; i<this.siteidCityData.length;i++){
                            if(myVuethis.siteidCityData[i].name==myVuethis.siteidCounty){
                                for(var n=0; n<myVuethis.siteidCityData[i].area.length;n++){
                                    let obj = {
                                    name:myVuethis.siteidCityData[i].area[n]
                                    }
                                    myVuethis.siteidCountyData.push(obj);
                                }
                            }
                        };
                    }
                       
                })
                .catch((error) => {
                    console.log(error);
                })
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.returnPath=from.path;
        })
    },
    created: function() {
        this.$route.meta.row!=undefined?localStorage.setItem("row",JSON.stringify(this.$route.meta.row)):"";
        localStorage.getItem("row")!=undefined? this.$route.meta.row=JSON.parse(localStorage.getItem("row")):"";
        this.initData();
    }
}
</script>
<style>
.el-form-module {
    width: 500px;
}

span.level1 {
    padding-left: 0;
}

span.level2 {
    padding-left: 12px;
}

span.level3 {
    padding-left: 24px;
}

span.level4 {
    padding-left: 36px;
}
</style>